<div class="delete-dialog-container">
  <h1 mat-dialog-title>Delete {{ _type }}</h1>
  <div *ngIf="!_element.title" mat-dialog-content>
    Would you like to delete
    <b>'{{ elementLabel() }}'</b> from DayDic ?
  </div>
  <div *ngIf="_element.title" mat-dialog-content>
    Would you like to delete <b>'{{ _element.title }}'</b> completely from DayDic?
  </div>
  <div *ngIf="_hasDic" mat-dialog-content>You can also only remove it from this dictionary.</div>
  <mat-dialog-actions align="end">
    <div class="dialog-actions-right">
      <button *ngIf="_hasDic" cdkFocusInitial mat-button mat-dialog-close [mat-dialog-close]="'delete-element-in-dic'">
        Only Remove from Dictionary
      </button>
      <button mat-button mat-dialog-close>No</button>
      <button cdkFocusInitial color="warn" mat-button mat-dialog-close [mat-dialog-close]="this._closeBtnCommand">
        Yes
      </button>
    </div>
  </mat-dialog-actions>
</div>
